<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Info-->
<div class="ItemGrid">
	<h4 class="SubHeading">Contact Info</h4>

	<label>First Name:</label>
	<input type="text" class="form-control" [(ngModel)]="FirstName" />

	<label>Last Name:</label>
	<input type="text" class="form-control" [(ngModel)]="LastName" />

	<label>Email:</label>
	<input type="text" class="form-control" [(ngModel)]="Email" />
</div>

<!--Email Types-->
<div class="ItemGrid TopMargin">
	<h4 class="SubHeading">Email Types</h4>

	<label for="OnBlocked">Blocked Visitor tries to Enter:</label>
	<input id="OnBlocked" type="checkbox" class="CHK" [(ngModel)]="OnBlocked" />

	<label for="OnConfirmedOffender">Confirmed Offender entered:</label>
	<input id="OnConfirmedOffender" type="checkbox" class="CHK" [(ngModel)]="OnConfirmedOffender" />

	<label for="OnNeedsVerification">Visitor needs Verification:</label>
	<input id="OnNeedsVerification" type="checkbox" class="CHK" [(ngModel)]="OnNeedsVerification" />
</div>

<!--List of Facilities-->
<div class="TopMargin">
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddFacility()">Add</button>
			<button class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteFacility()">Remove</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstFacility"
			[loading]="loading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedFacilities"
			dataKey="FacilityID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--FacilityCD-->
					<th>
						<p-columnFilter type="text" field="FacilityCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FacilityName-->
					<th>
						<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox [disabled]="IsLoading() == true"></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="FacilityCD">Code<p-sortIcon field="FacilityCD"></p-sortIcon></th>
					<th pSortableColumn="FacilityName">Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Facility>
				<tr [pSelectableRow]="Facility" (dblclick)="onRowDblClick(Facility)">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Facility" [value]="Facility"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Facility[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Update</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
